import { leftToRightMark } from "@jti/fe-common";
export const getCountriesCodesArray = (config) => {
    return (config.TELEPHONE_CODES_LIST || "").split(",").map((value) => ({
        value,
        label: `${leftToRightMark}${value}`,
    }));
};
//# sourceMappingURL=countryCode.js.map